<template>
  <div :style="{ height: (seHeight || height) + 'px' }">
    <vxe-table
      :height="(seHeight || height) - 40"
      ref="vxeTable"
      class="cml-table-custom"
      size="mini"
      border
      resizable
      auto-resize
      :row-id="rowId"
      column-key
      v-loading="loading"
      highlight-current-row
      :show-overflow="showOverflow"
      :data="tableData.list"
      :sort-config="{ orders: ['desc', 'asc'], remote: true }"
      :radio-config="{ trigger: 'row' }"
      :column-config="{ minWidth: '80px'}"
      :checkbox-config="{ reserve: true }"
      :scroll-y="{ enabled: scrollYEnabled }"
      @cell-click="cellClick"
      @sort-change="sortChange"
      @checkbox-change="selectChangeEvent"
      @checkbox-all="selectAllEvent"
    >
      <vxe-table-column
        v-if="showCheckbox"
        type="checkbox"
        width="50"
      ></vxe-table-column>
      <vxe-table-column v-if="showRadioBox" type="radio" width="50"></vxe-table-column>

      <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
      <!-- 自定义内容 -->
      <vxe-table-column
        v-for="item in tableHead"
        :show-overflow="showOverflow"
        :field="item.prop"
        :title="item.label"
        :key="item.prop"
        :sortable="item.sortable"
        :width="item.width"
        :fixed="item.fixed"
        :min-width="item.minWidth || 100"
      >
        <template #header>{{ item.label }}</template>
        <template v-if="item.slotColumn" v-slot="{ row, rowIndex }">
          <slot :name="item.slotName" :row="row" :rowIndex="rowIndex" />
        </template>
        <template v-else v-slot="{ row }">
          {{ formatCellValue(row[item.prop], item.type) }}
        </template>
      </vxe-table-column>
    </vxe-table>

    <vxe-pager
      v-if="showPage"
      class="cml-pagination"
      background
      size="small"
      :current-page="tableParam.pageNo"
      :page-size="tableParam.pageSize"
      :total="tableData.total"
      :page-sizes="[10, 20, 50, 100, 200, 500]"
      :layouts="layouts"
      @page-change="handlePageChange"
    >
    </vxe-pager>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  props: {
    seHeight: {
      type: Number,
      default: 0,
    },
    // 是否关闭y轴上的虚拟滚动
    scrollYEnabled: {
      type: Boolean,
      default: true,
    },
    showCheckbox: {
      type: Boolean,
      default: true,
    },
    showRadioBox:  {
      type: Boolean,
      default: false,
    },
    rowId: {
      type: String,
      default: 'id',
    },
    showPage: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    tableData: {
      type: Object,
      default() {
        return {
          list: [],
        };
      },
    },
    tableHead: {
      type: Array,
      default() {
        return [];
      },
    },
    tableParam: {
      type: Object,
      default() {
        return {
          pageSize: 100,
          pageNo: 1,
        };
      },
    },
    layouts: {
      type: Array,
      default() {
        return [
          'PrevPage',
          'JumpNumber',
          'NextPage',
          'FullJump',
          'Sizes',
          'Total',
        ];
      },
    },
  },
  data() {
    return {
      height: '300px',
      showOverflow: true,
    };
  },
  watch: {
    'tableData.list' : {
      deep: true,
      immediate: true,
      handler() {
        setTimeout(() => {
          this.scrollTo(0)
        },10)
      }
    }
  },
  methods: {
    formatCellValue(value, type) {
      if (type === 'time' && value) {
        return dayjs(value).format('YYYY-MM-DD HH:mm:ss');
      }
      return value;
    },
    refreshColumn() {
      this.$refs.vxeTable.refreshColumn();
    },
    selectChangeEvent({ records }) {
      this.$emit('select-change', records);
    },
    selectAllEvent({ records }) {
      this.$emit('select-change', records);
    },
    cellClick({ row }) {
      this.$emit('radio-change', row);
    },
    handlePageChange({ currentPage, pageSize }) {
      this.$emit('page-size-change', currentPage, pageSize);
    },
    sortChange(val) {
      if (!val.order || val.order === null) {
        this.$emit('sort-change', '');
      } else {
        this.$emit('sort-change', val.property + ' ' + val.order);
      }
    },
    clearSort() {
      this.$refs.vxeTable.clearSort();
    },
    // 取消多选
    clearCheckboxRow() {
      this.$refs.vxeTable.clearCheckboxRow();
    },
    // 取消单选
    clearRadioRow () {
      this.$refs.vxeTable.clearRadioRow()
    },
    // 单选选中
    setRadioRow (row) {
      this.$refs.vxeTable.setRadioRow(row)
    },
    getCheckboxReserveRecords() {
      return this.$refs.vxeTable.getCheckboxReserveRecords();
    },
    // 动态改变表格高度
    changeHeight(num) {
      // 显示明细打开状态
      this.$nextTick(() => {
        this.height = this.$computeTableHeight.computeTableHeight(
          undefined,
          num,
        );
      });
    },
    // 滚动条到达的地方
    scrollTo(num) {
      this.$refs.vxeTable.scrollTo(0,num)
    }
  },
};
</script>

<style lang="less">
.cml-table-custom
  .vxe-table--render-default.size--mini
  .vxe-header--column.col--ellipsis
  > .vxe-cell,
.vxe-table--render-default.size--mini
  .vxe-body--column.col--ellipsis
  > .vxe-cell,
.vxe-table--render-default.size--mini
  .vxe-footer--column.col--ellipsis
  > .vxe-cell {
  max-height: 100px !important;
}
//表内容的边框颜色
.vxe-table--render-default.border--full .vxe-body--column {
  // background-image: linear-gradient(red, red), linear-gradient(red, red);
  background-size: 1px 100%, 100% 1px;
}
</style>
